// v2.18.6 — Wrapper partagé pour TOUS les *_grid de cards dans le chat.
// Garantit cohérence cross-modes (santé, justice, divertissement, emploi,
// admin, finance, casual featured) : flex + overflow-x + scroll-snap +
// padding constant + touch smooth iOS. Remplace les `display: grid` qui
// cassent en pleine largeur sur mobile.

export default function HorizontalCardList({ testId, children, className = "civ-featured-row", style = {} }) {
  return (
    <div
      data-testid={testId}
      className={className}
      style={{
        display: "flex",
        overflowX: "auto",
        overflowY: "hidden",
        gap: 12,
        padding: "8px 16px 18px",
        scrollSnapType: "x mandatory",
        WebkitOverflowScrolling: "touch",
        marginTop: 10,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
